import React from 'react';
import { Trans, t } from '@lingui/macro';
import { AppNotificationBar } from 'components/AppNotificationBar';
import { CONFIG } from 'utils/config';
import { useExecutionEnvironmentContext } from 'contexts/ExecutionEnvironmentContext/ExecutionEnvironmentContext';

interface UsePlanPausedBanner {
    goToAccountPlans: () => void;
}

export const usePlanPausedBanner = ({
    isDAWPlugin,
}: {
    isDAWPlugin: boolean;
}): UsePlanPausedBanner => {
    const goToAccountPlans = () => {
        const target = isDAWPlugin ? '_blank' : '_self';

        window.open(`${CONFIG.VITE_ACCOUNT_PLANS_URL}`, target);
    };

    return { goToAccountPlans };
};

export const _PlanPausedBanner = ({
    goToAccountPlans,
}: {
    goToAccountPlans: () => void;
}) => (
    <AppNotificationBar
        variant="warning"
        action={{
            children: t`Resume`,
            onClick: goToAccountPlans,
        }}
    >
        <Trans>
            <strong>You subscription is paused.</strong> To access your
            functionalities again, resume your plan.
        </Trans>
    </AppNotificationBar>
);

const PlanPausedBanner = () => {
    const { isDAWPlugin } = useExecutionEnvironmentContext();
    const { goToAccountPlans } = usePlanPausedBanner({ isDAWPlugin });

    return <_PlanPausedBanner goToAccountPlans={goToAccountPlans} />;
};

export default PlanPausedBanner;
